import React, { useState, useEffect } from 'react'
import Footer from './Footer'
import Header from './Header'
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2'

import ReactLoading from 'react-loading';
import config from "../../config"



const Create_int_order = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get('order_id'); // Get the order ID from the URL
  const [isEditing, setIsEditing] = useState(!!orderId); // Check if we're in edit mode
  let navigate = useNavigate();
  const [state, setState] = React.useState({
    parcel_type: "Parcel", order_date: "", order_number: "", int_type: "Export", int_mode: "Air", int_use_type: "Personal", usps_no: "CSB-5", company_name: "",
    full_person_name: "",
    complete_address: "",
    country: "",
    country_id: "",
    state_id: "",
    state_name: "",
    city: "",
    city_id: "",
    pincode: "",
    mobile_number: "",
    email_id: "",
    dialling_code: "+91",
    kyc_type_1: "AADHAAR NUMBER",
    kyc_number_1: "",
    kyc_type_2: "AADHAAR NUMBER",
    kyc_number_2: "",
    kyc_document_1: null,
    kyc_document_2: null,
    consignee_company_name: "",
    consignee_full_person_name: "",
    consignee_complete_address: "",
    consignee_country: "",
    consignee_country_id: "",
    consignee_state_name: "",
    consignee_state_id: "",
    consignee_city: "",
    consignee_city_id: "",
    consignee_pincode: "",
    consignee_mobile_number: "",
    consignee_dialling_code: "",
    consignee_email_id: "",
    consignee_kyc_type: "LOCAL ID COPY",
    consignee_kyc_number: "",
    consignee_kyc_document_1: null,
    consignee_kyc_document_2: null,
    invoice_type: "Invoice",
    incoterms: "CFR",
    invoice_note: "SAMPLE",
    currency: 'USD',
    items: [
      {
        box_no: 1,
        sr_no: 1,
        description: "",
        hs_code: "",
        unit_type: "Pkt",
        quantity: 1,
        igst: "",
        unit_rate: 0,
        amount: 0,
      },
    ],
  })
  console.log("state == ", state)
  const [addbutton, setaddbutton] = useState(false)
  const [parceltype, setparceltypeState] = useState({ parcel: true })
  const [documenttype, setdocumenttypeState] = useState({ document: false })
  const [exporttype, setexporttypeState] = useState({ export: true })
  const [importtype, setimporttypeState] = useState({ import: false })
  const [airmodetype, setairmodetypeState] = useState({ air: true })
  const [seamodetype, setseamodetypeState] = useState({ sea: false })
  const [usectype, setusectypeState] = useState({ commercial: false })
  const [useptype, setuseptypeState] = useState({ personal: true })
  const [countryList, setcountryList] = React.useState([]);
  const [stateList, setStateList] = React.useState([]);
  const [consigneestateList, setconsigneeStateList] = React.useState([]);
  const [cityList, setCityList] = React.useState([]);
  const [consigneecityList, setconsigneeCityList] = React.useState([]);
  const dialingCodes = {
    "Afghanistan": "+93",
    "Albania": "+355",
    "Algeria": "+213",
    "Andorra": "+376",
    "Angola": "+244",
    "Antigua and Barbuda": "+1-268",
    "Argentina": "+54",
    "Armenia": "+374",
    "Australia": "+61",
    "Austria": "+43",
    "Azerbaijan": "+994",
    "Bahamas": "+1-242",
    "Bahrain": "+973",
    "Bangladesh": "+880",
    "Barbados": "+1-246",
    "Belarus": "+375",
    "Belgium": "+32",
    "Belize": "+501",
    "Benin": "+229",
    "Bhutan": "+975",
    "Bolivia": "+591",
    "Bosnia and Herzegovina": "+387",
    "Botswana": "+267",
    "Brazil": "+55",
    "Brunei": "+673",
    "Bulgaria": "+359",
    "Burkina Faso": "+226",
    "Burundi": "+257",
    "Cambodia": "+855",
    "Cameroon": "+237",
    "Canada": "+1",
    "Cape Verde": "+238",
    "Central African Republic": "+236",
    "Chad": "+235",
    "Chile": "+56",
    "China": "+86",
    "Colombia": "+57",
    "Comoros": "+269",
    "Congo (Kinshasa)": "+243",
    "Congo (Brazzaville)": "+242",
    "Costa Rica": "+506",
    "Croatia": "+385",
    "Cuba": "+53",
    "Cyprus": "+357",
    "Czech Republic": "+420",
    "Denmark": "+45",
    "Djibouti": "+253",
    "Dominica": "+1-767",
    "Dominican Republic": "+1-809, +1-829, +1-849",
    "Ecuador": "+593",
    "Egypt": "+20",
    "El Salvador": "+503",
    "Equatorial Guinea": "+240",
    "Eritrea": "+291",
    "Estonia": "+372",
    "Eswatini": "+268",
    "Ethiopia": "+251",
    "Fiji": "+679",
    "Finland": "+358",
    "France": "+33",
    "Gabon": "+241",
    "Gambia": "+220",
    "Georgia": "+995",
    "Germany": "+49",
    "Ghana": "+233",
    "Greece": "+30",
    "Grenada": "+1-473",
    "Guatemala": "+502",
    "Guinea": "+224",
    "Guinea-Bissau": "+245",
    "Guyana": "+592",
    "Haiti": "+509",
    "Honduras": "+504",
    "Hungary": "+36",
    "Iceland": "+354",
    "India": "+91",
    "Indonesia": "+62",
    "Iran": "+98",
    "Iraq": "+964",
    "Ireland": "+353",
    "Israel": "+972",
    "Italy": "+39",
    "Jamaica": "+1-876",
    "Japan": "+81",
    "Jordan": "+962",
    "Kazakhstan": "+7",
    "Kenya": "+254",
    "Kiribati": "+686",
    "Kuwait": "+965",
    "Kyrgyzstan": "+996",
    "Laos": "+856",
    "Latvia": "+371",
    "Lebanon": "+961",
    "Lesotho": "+266",
    "Liberia": "+231",
    "Libya": "+218",
    "Liechtenstein": "+423",
    "Lithuania": "+370",
    "Luxembourg": "+352",
    "Madagascar": "+261",
    "Malawi": "+265",
    "Malaysia": "+60",
    "Maldives": "+960",
    "Mali": "+223",
    "Malta": "+356",
    "Marshall Islands": "+692",
    "Mauritania": "+222",
    "Mauritius": "+230",
    "Mexico": "+52",
    "Micronesia": "+691",
    "Moldova": "+373",
    "Monaco": "+377",
    "Mongolia": "+976",
    "Montenegro": "+382",
    "Morocco": "+212",
    "Mozambique": "+258",
    "Myanmar": "+95",
    "Namibia": "+264",
    "Nauru": "+674",
    "Nepal": "+977",
    "Netherlands": "+31",
    "New Zealand": "+64",
    "Nicaragua": "+505",
    "Niger": "+227",
    "Nigeria": "+234",
    "North Macedonia": "+389",
    "Norway": "+47",
    "Oman": "+968",
    "Pakistan": "+92",
    "Palau": "+680",
    "Panama": "+507",
    "Papua New Guinea": "+675",
    "Paraguay": "+595",
    "Peru": "+51",
    "Philippines": "+63",
    "Poland": "+48",
    "Portugal": "+351",
    "Qatar": "+974",
    "Romania": "+40",
    "Russia": "+7",
    "Rwanda": "+250",
    "Saint Kitts and Nevis": "+1-869",
    "Saint Lucia": "+1-758",
    "Saint Vincent and the Grenadines": "+1-784",
    "Samoa": "+685",
    "San Marino": "+378",
    "Sao Tome and Principe": "+239",
    "Saudi Arabia": "+966",
    "Senegal": "+221",
    "Serbia": "+381",
    "Seychelles": "+248",
    "Sierra Leone": "+232",
    "Singapore": "+65",
    "Slovakia": "+421",
    "Slovenia": "+386",
    "Solomon Islands": "+677",
    "Somalia": "+252",
    "South Africa": "+27",
    "South Korea": "+82",
    "Spain": "+34",
    "Sri Lanka": "+94",
    "Sudan": "+249",
    "Suriname": "+597",
    "Sweden": "+46",
    "Switzerland": "+41",
    "Syria": "+963",
    "Taiwan": "+886",
    "Tajikistan": "+992",
    "Tanzania": "+255",
    "Thailand": "+66",
    "Togo": "+228",
    "Tonga": "+676",
    "Trinidad and Tobago": "+1-868",
    "Tunisia": "+216",
    "Turkey": "+90",
    "Turkmenistan": "+993",
    "Tuvalu": "+688",
    "Uganda": "+256",
    "Ukraine": "+380",
    "United Arab Emirates": "+971",
    "United Kingdom": "+44",
    "United States": "+1",
    "Uruguay": "+598",
    "Uzbekistan": "+998",
    "Vanuatu": "+678",
    "Vatican City": "+379",
    "Venezuela": "+58",
    "Vietnam": "+84",
    "Yemen": "+967",
    "Zambia": "+260",
    "Zimbabwe": "+263"
  };
  const [pcs, setPcs] = useState(1); // Initial PCS count (default is 1)
  const [rows, setRows] = useState([
    { box_no: 1, actualWeight: '', height: '', width: '', length: '', volumetricWeight: '', chargeableWeight: '' },
  ]);

  console.log("rows ==", rows)
  const [totalActualWeight, setTotalActualWeight] = useState(0);
  const [totalVolumetricWeight, setTotalVolumetricWeight] = useState(0);
  const [totalChargeableWeight, setTotalChargeableWeight] = useState(0);

  React.useEffect(() => {
    if (orderId) {
      // Fetch order data if in edit mode
      fetchOrderData(orderId);
      getCountryList()
    }
    else {

      generateOrderNumber()
      getCountryList()

    }
  }, []);

  const fetchOrderData = async (orderId) => {
    try {
      const url = `${config.apiUrl}/shipment/get_order`;
      let sendata = { order_number: orderId }
      const response = await axios.post(url, sendata, { headers: config.headers });

      if (response.data.status === true) {
        const orderData = response.data.output[0];
        setState({
          parcel_type: orderData.type, order_date: orderData.order_date, order_number: orderData.order_number, int_type: orderData.int_type, int_mode: orderData.int_mode, int_use_type: orderData.int_use_type, usps_no: orderData.usps_no, company_name: orderData.sender[0].company_name,
          full_person_name: orderData.sender[0].name,
          complete_address: orderData.sender[0].address,
          country: orderData.sender[0].country,
          country_id: 244,
          state_id: "",
          state_name: orderData.sender[0].state,
          city: orderData.sender[0].city,
          city_id: orderData.sender[0].city_id,
          pincode: orderData.sender[0].pincode,
          mobile_number: orderData.sender[0].mobile,
          email_id: orderData.sender[0].email,
          dialling_code: "+91",
          kyc_type_1: orderData.shipper_kyc_type_1,
          kyc_number_1: orderData.shipper_kyc_number_1,
          kyc_type_2: orderData.shipper_kyc_type_2,
          kyc_number_2: orderData.shipper_kyc_number_2,
          kyc_document_1: orderData.shipper_kyc_document_1,
          kyc_document_2: orderData.shipper_kyc_document_2,
          consignee_company_name: orderData.receiver[0].company_name,
          consignee_full_person_name: orderData.receiver[0].name,
          consignee_complete_address: orderData.receiver[0].address,
          consignee_country: orderData.receiver[0].country,
          consignee_country_id: "",
          consignee_state_name: orderData.receiver[0].state,
          consignee_state_id: "",
          consignee_city: orderData.receiver[0].city,
          consignee_city_id: "",
          consignee_pincode: orderData.receiver[0].pincode,
          consignee_mobile_number: orderData.receiver[0].mobile,
          consignee_dialling_code: dialingCodes[orderData.receiver[0].country],
          consignee_email_id: orderData.receiver[0].email,
          consignee_kyc_type: orderData.consignee_kyc_type,
          consignee_kyc_number: orderData.consignee_kyc_number,
          consignee_kyc_document_1: orderData.consignee_kyc_document_1,
          consignee_kyc_document_2: orderData.consignee_kyc_document_2,
          invoice_type: orderData.invoice_type,
          incoterms: orderData.incoterms,
          invoice_note: orderData.invoice_note,
          currency: orderData.currency,
          items: orderData.invoice_items,
        }); // Populate the state with fetched order data
        setPcs(orderData.int_dimensions.length); // Set the number of boxes
        setRows(orderData.int_dimensions); // Set the rows data
        if (orderData.type == "Parcel") {
          setparceltypeState({ parcel: true })
          setdocumenttypeState({ document: false })
        }
        else {
          setparceltypeState({ parcel: false })
          setdocumenttypeState({ document: true })
        }

        if (orderData.int_type == "Import") {
          setexporttypeState({ export: false })
          setimporttypeState({ import: true })
        }
        else {
          setexporttypeState({ export: true })
          setimporttypeState({ import: false })
        }

        if (orderData.int_mode == "Air") {
          setairmodetypeState({ air: true })
          setseamodetypeState({ sea: false })
        }
        else {
          setairmodetypeState({ air: false })
          setseamodetypeState({ sea: true })
        }


        if (orderData.int_use_type == "Personal") {
          setusectypeState({ commercial: false })
          setuseptypeState({ personal: true })
        }
        else {
          setusectypeState({ commercial: true })
          setuseptypeState({ personal: false })
        }
        let url = config.apiUrl + '/country/city_list';
        let sendData = { state_id: orderData.sender[0].state_id, country_id: 229, limit: 1000 };
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
          setCityList(res.data.output)
        }).catch((e) => {
        });

      } else {
        Swal.fire({
          title: "Error fetching order data!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error fetching order data!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handlePcsChange = (e) => {
    const numPcs = e.target.value;
    setPcs(numPcs);
    setRows(Array.from({ length: numPcs }, (_, index) => ({
      box_no: index + 1,
      actualWeight: '',
      height: '',
      width: '',
      length: '',
      volumetricWeight: '',
      chargeableWeight: ''
    })));
  };


  // Handle individual row input change
  const handleInputChange = (e, index, field) => {
    const value = e.target.value;
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    // Perform calculations
    if (['height', 'width', 'length'].includes(field)) {
      // Calculate Volumetric Weight
      const { height, width, length } = updatedRows[index];
      if (height && width && length) {
        const volumetricWeight = (parseFloat(height) * parseFloat(width) * parseFloat(length)) / 5000;
        updatedRows[index].volumetricWeight = parseFloat(volumetricWeight.toFixed(2));
      }
    }

    // Ensure Actual Weight is a valid number
    if (field === 'actualWeight' || ['height', 'width', 'length'].includes(field)) {
      const actualWeight = parseFloat(updatedRows[index].actualWeight) || 0;
      const volumetricWeight = parseFloat(updatedRows[index].volumetricWeight) || 0;

      // Calculate Chargeable Weight (Highest between Actual & Volumetric)
      updatedRows[index].chargeableWeight = Math.max(actualWeight, volumetricWeight).toFixed(2);
    }

    setRows(updatedRows);
    calculateTotals(updatedRows);
  };

  // Calculate totals
  const calculateTotals = (updatedRows) => {
    const actualWeightSum = updatedRows.reduce((sum, row) => sum + parseFloat(row.actualWeight || 0), 0);
    const volumetricWeightSum = updatedRows.reduce((sum, row) => sum + parseFloat(row.volumetricWeight || 0), 0);
    const chargeableWeightSum = updatedRows.reduce((sum, row) => sum + parseFloat(row.chargeableWeight || 0), 0);

    setTotalActualWeight(actualWeightSum);
    setTotalVolumetricWeight(volumetricWeightSum);
    setTotalChargeableWeight(chargeableWeightSum);
  };


  const generateOrderNumber = () => {
    // Generate the order number logic
    const randomNumber = Math.floor(Math.random() * 1000000);
    const formattedOrderNumber = + randomNumber;


    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    let order_date = `${year}-${month}-${day}`;
    setState({ ...state, order_number: formattedOrderNumber, order_date: order_date })
  }

  const handleChange = (e) => {
    console.log("e.target.type==", e.target.name)
    let names = e.target.name
    let value = e.target.value

    if (e.target.type == "text") {
      setState({ ...state, [e.target.name]: value })
    }
    else if (e.target.type == "radio") {
      if (e.target.checked == true) {

        if (e.target.name == "document") {
          setparceltypeState({ ...parceltype, parcel: false })
          setdocumenttypeState({ ...documenttype, document: true })
          setState({ ...state, parcel_type: "Document" })
        }
        else if (e.target.name == "parcel") {
          setparceltypeState({ ...parceltype, parcel: true })
          setdocumenttypeState({ ...documenttype, document: false })
          setState({ ...state, parcel_type: "Parcel" })
        }
        else if (e.target.name == "export") {
          setexporttypeState({ ...exporttype, export: true })
          setimporttypeState({ ...importtype, import: false })
          setState({ ...state, int_type: "Export" })
        }
        else if (e.target.name == "import") {
          setexporttypeState({ ...exporttype, export: false })
          setimporttypeState({ ...importtype, import: true })
          setState({ ...state, int_type: "Import" })
        }
        else if (e.target.name == "air") {
          setairmodetypeState({ ...airmodetype, air: true })
          setseamodetypeState({ ...seamodetype, sea: false })
          setState({ ...state, int_mode: "Air" })
        }
        else if (e.target.name == "sea") {
          setairmodetypeState({ ...airmodetype, air: false })
          setseamodetypeState({ ...seamodetype, sea: true })
          setState({ ...state, int_mode: "Sea" })
        }
        else if (e.target.name == "personal") {
          setuseptypeState({ ...useptype, personal: true })
          setusectypeState({ ...usectype, commercial: false })
          setState({ ...state, int_use_type: "Personal" })
        }
        else if (e.target.name == "commercial") {
          setuseptypeState({ ...useptype, personal: false })
          setusectypeState({ ...usectype, commercial: true })
          setState({ ...state, int_use_type: "Commercial" })
        }
      }
    }
    else if (e.target.type == "number") {
      setState({ ...state, [e.target.name]: value })
    }
    else if (e.target.type == "date") {
      setState({ ...state, [e.target.name]: value })

    }
    else if (e.target.type == "select-one") {
      if (e.target.name == "usps_no") {
        setState({ ...state, usps_no: value })
      }
      else if (e.target.name == "kyc_type_1") {
        setState({ ...state, kyc_type_1: value })
      }
      else if (e.target.name == "kyc_type_2") {
        setState({ ...state, kyc_type_2: value })
      }
    }
  }


  const getCountryList = () => {
    let url = config.apiUrl + '/country/country_list';
    let sendData = { limit: 300, status: 1 };
    axios.post(url, sendData, { headers: config.headers }).then((res) => {
      const countries = res.data.output;
      setcountryList(countries)
      const india = countries.find((country) => country.country_id === 229);
      if (india) {
        const randomNumber = Math.floor(Math.random() * 1000000);
        const formattedOrderNumber = + randomNumber;
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        let order_date = `${year}-${month}-${day}`;
        if (orderId) {

        }
        else {
          setState({ ...state, country: india.country_name, country_id: india.country_id, order_number: formattedOrderNumber, order_date: order_date });
        }
        let url = config.apiUrl + '/country/state_list';
        let sendData = { t_country_id: india.country_id, limit: 1000 };
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
          setStateList(res.data.output)
        }).catch((e) => {
        });
      }
    }).catch((e) => {
    });
  }

  const handleChangeShipperState = (e) => {
    const selectedState = JSON.parse(e.target.value);

    setState({ ...state, state_id: selectedState.state_id, state_name: selectedState.state_name })

    let url = config.apiUrl + '/country/city_list';
    let sendData = { state_id: selectedState.state_id, country_id: state.country_id, limit: 1000 };
    axios.post(url, sendData, { headers: config.headers }).then((res) => {
      setCityList(res.data.output)
    }).catch((e) => {
    });
  }
  const handleChangeShipperCity = (e) => {
    const selectedCity = JSON.parse(e.target.value);
    setState({ ...state, city_id: selectedCity.city_id, city: selectedCity.city_name })
  }

  //  const handleChangeConsigneeCity = (e)=>{
  //   const selectedCity = JSON.parse(e.target.value); 
  //   setState({...state, consignee_city_id: selectedCity.city_id , consignee_city: selectedCity.city_name})
  // }

  //  const handleChangeConsigneeState=(e)=>{
  //     const selectedState = JSON.parse(e.target.value); 

  //     setState({...state, consignee_state_id: selectedState.state_id , consignee_state_name: selectedState.state_name})

  //     let url = config.apiUrl + '/country/city_list';
  //     let sendData = { state_id: selectedState.state_id , country_id:state.country_id, limit: 1000 };
  //     axios.post(url, sendData, { headers: config.headers }).then((res) => {
  //       setconsigneeCityList(res.data.output)
  //     }).catch((e) => {
  //   });
  // }

  const handleChangeConsigneeCountry = (e) => {
    const selectedState = JSON.parse(e.target.value);

    setState({ ...state, consignee_country_id: selectedState.country_id, consignee_country: selectedState.country_name, consignee_dialling_code: dialingCodes[selectedState.country_name] || "" })

    let url = config.apiUrl + '/country/state_list';
    let sendData = { t_country_id: selectedState.country_id, limit: 1000 };
    axios.post(url, sendData, { headers: config.headers }).then((res) => {
      setconsigneeStateList(res.data.output)
    }).catch((e) => {
    });
  }

  const addNewRow = () => {
    const newRow = {
      box_no: 1,
      sr_no: state.items.length + 1,
      description: '',
      hs_code: '',
      unit_type: 'Pkt',
      quantity: 1,
      igst: "",
      unit_rate: 0,
      amount: 0,
    };
    setState((prevState) => ({
      ...prevState,
      items: [...prevState.items, newRow],
    }));
  };

  const removeRow = () => {
    setState((prevState) => {
      const newItems = [...prevState.items];
      newItems.pop(); // Remove the last row from the array
      return { ...prevState, items: newItems };
    });
  };
  const handleChange1 = (e, index, field) => {
    const value = e.target.value;
    const updatedItems = [...state.items];
    updatedItems[index][field] = value;
    if (field === "quantity" || field === "unit_rate") {
      // Calculate amount when quantity or unit rate changes
      updatedItems[index].amount = updatedItems[index].quantity * updatedItems[index].unit_rate;
    }
    setState((prevState) => ({
      ...prevState,
      items: updatedItems,
    }));
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0]; // Get the first file from the input
    if (file) {
      setState((prevState) => ({
        ...prevState,
        [fieldName]: file, // Set the file to the respective field in the state
      }));
    }
  };

  const saveOrder = () => {
    setaddbutton(true);

    // Validate necessary fields
    if (

      !state.full_person_name ||
      !state.complete_address ||
      !state.country ||
      !state.state_name ||
      !state.city ||
      !state.pincode||
      !state.mobile_number ||
      !state.email_id || 
      !state.kyc_number_1 ||
      !state.kyc_document_1 ||
      !state.consignee_full_person_name ||
      !state.consignee_complete_address ||
      !state.consignee_country ||
      !state.consignee_state_name ||
      !state.consignee_city ||
      !state.consignee_pincode||
      !state.consignee_mobile_number || 
      !state.consignee_email_id
    ) {
      Swal.fire({
        title: "Please fill all required fields!",
        icon: "error",
        confirmButtonText: "OK",
      });
      setaddbutton(false);
      return;
    }

    // Validate pcs should not be less than 1
    if (pcs < 1) {
      Swal.fire({
        title: "PCS count should not be less than 1!",
        icon: "error",
        confirmButtonText: "OK",
      });
      setaddbutton(false);
      return;
    }

    // Ensure necessary fields in each item are present
    const invalidItems = state.items.some(
      (item) =>
        !item.description ||
        !item.hs_code ||
        !item.quantity ||
        !item.unit_rate

    );

    if (invalidItems) {
      Swal.fire({
        title: "All Shipment Invoice details  are required!",
        icon: "error",
        confirmButtonText: "OK",
      });
      setaddbutton(false);
      return;
    }


    const invalidRow = rows.some(
      (item) =>
        !item.actualWeight ||
        !item.height ||
        !item.width ||
        !item.length

    );

    if (invalidRow) {
      Swal.fire({
        title: "Weight And Dimensions all details  are required!",
        icon: "error",
        confirmButtonText: "OK",
      });
      setaddbutton(false);
      return;
    }

    const rowBoxNumbers = rows.map((row) => parseInt(row.box_no)); // Ensure numbers
    console.log("rowBoxNumbers == ", rowBoxNumbers);

    const existingBoxNumbers = state.items.map((item) => parseInt(item.box_no)); // Ensure numbers
    const missingBoxes = rowBoxNumbers.filter((box_no) => !existingBoxNumbers.includes(box_no));

    console.log("Missing Boxes: ", missingBoxes);


    if (missingBoxes.length > 0) {
      Swal.fire({
        title: "Each item must be assigned to a valid box!",
        icon: "error",
        confirmButtonText: "OK",
      });
      setaddbutton(false);
      return;
    }

    // Create a new FormData object to handle file uploads
    const formData = new FormData();

    // Append regular fields
    formData.append('state', JSON.stringify(state));
    formData.append('pcs', pcs);
    formData.append('rows', JSON.stringify(rows));
    formData.append('totalActualWeight', totalActualWeight);
    formData.append('totalVolumetricWeight', totalVolumetricWeight);
    formData.append('totalChargeableWeight', totalChargeableWeight);

    // Append the image files (kyc_document_1, kyc_document_2, consignee_kyc_document)
    if (state.kyc_document_1) {
      formData.append('kyc_document_1', state.kyc_document_1);
    }
    if (state.kyc_document_2) {
      formData.append('kyc_document_2', state.kyc_document_2);
    }
    if (state.consignee_kyc_document_1) {
      formData.append('consignee_kyc_document_1', state.consignee_kyc_document_1);
    }
    if (state.consignee_kyc_document_2) {
      formData.append('consignee_kyc_document_1', state.consignee_kyc_document_2);
    }
    console.log("formData == ", formData)
    // API URL and POST request
    let url = config.apiUrl + '/shipment/int_order_create';
    axios
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',  // Important for file uploads
          ...config.headers, // Any other headers you may need
        },
      })
      .then((responseJson) => {
        if (responseJson.data.status === true) {
          navigate({ pathname: `/international_orders` });
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#3659cd",
            type: 'unsuccess',
            title: "Order created successfully.",
            color: "white",
          });
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#a61c09",
            type: 'unsuccess',
            title: "Something Went Wrong.",
            color: "white",
          });
        }
        setaddbutton(false);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error occurred!",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
        setaddbutton(false);
      });
  };
  return (
    <div>
      <Header />
      <div class="page-wrapper pinned">
        <div class="main-container">
          <div className='app-container'>
            <div class="app-body">
              <div class="container-fluid">

                <div class="mob_nav">
                  <div class=" d-flex justify-content-start ">
                    <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
                    <h2>Create International Order</h2>
                  </div>
                </div>

                <div class="row justify-content-between">
                  <div class="col-12 col-md-4 desk_nav">
                    <div class="d-flex">
                      <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                      <h2>Create International Order</h2>
                    </div>
                  </div>

                </div>


                <section class="">
                  <div class="row">
                    <div class="col-12 col-md-12">
                      <div class="row">
                        <div class="col-12 col-md-12 mb-3">
                          <h4>Order Details</h4>
                          <div class="card">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-12 col-md-4 mb-3">
                                  <label for="" class="form-label">Order ID: <small class="text-muted">(Leave Blank for Auto Generate)</small></label>
                                  <input type="text" class="form-control" id="" placeholder="Order ID" value={state.order_number} name="order_number" onChange={(e) => handleChange(e)} disabled />
                                </div>
                                <div class="col-12 col-md-4 mb-3">
                                  <label for="" class="form-label">Order Date: <small class="text-muted">(Leave Blank for Auto Generate)</small></label>
                                  <input type="date" class="form-control" id="" placeholder="Enter Full Name" value={state.order_date} name="order_date" onChange={(e) => handleChange(e)} />
                                </div>
                                <div class="col-12 col-md-4 mb-3">
                                  {/* <label for="" class="form-label">Reference Number: </label>
                      <input type="text" class="form-control" id="" placeholder="Enter number" name=""/> */}
                                </div>
                                <div class="col-12 col-md-3 mb-3">
                                  <label for="" class="form-label">Product: </label>
                                  <div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="parcel" onChange={(e) => handleChange(e)} id="inlixneRadio2" value="Parcel" checked={parceltype.parcel == true && documenttype.document == false} />
                                      <label class="form-check-label" for="">SPX - Non DOC</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" id="inlineRadio2" onChange={(e) => handleChange(e)} name="document" value="Document" checked={documenttype.document == true && parceltype.parcel == false} />
                                      <label class="form-check-label" for="inlineRadio2">DOX - DOC</label>
                                    </div>
                                  </div>
                                </div>
                                {/* <div class="col-12 col-md-3 mb-3">
                                  <label for="" class="form-label">Type: </label>
                                  <div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="export" onChange={(e) => handleChange(e)} id="inlixneRadio2" value="Export" checked={exporttype.export == true && importtype.import == false} />
                                      <label class="form-check-label" for="">Export</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="import" onChange={(e) => handleChange(e)} id="inlixneRadio2" value="Import" checked={importtype.import == true && exporttype.export == false} />
                                      <label class="form-check-label" for="inlineRadio2">Import</label>
                                    </div>
                                  </div>
                                </div> */}
                                {/* <div class="col-12 col-md-3 mb-3">
                                  <label for="" class="form-label">Mode: </label>
                                  <div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="air" onChange={(e) => handleChange(e)} id="inlixneRadio2" value="Air" checked={airmodetype.air == true && seamodetype.sea == false} />
                                      <label class="form-check-label" for="">Air</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="sea" onChange={(e) => handleChange(e)} id="inlixneRadio2" value="Sea" checked={airmodetype.air == false && seamodetype.sea == true} />
                                      <label class="form-check-label" for="inlineRadio2">Sea</label>
                                    </div>
                                  </div>
                                </div> */}
                                {/* <div class="col-12 col-md-3 mb-3">
                                  <label for="" class="form-label">Use Type: </label>
                                  <div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="personal" onChange={(e) => handleChange(e)} id="inlixneRadio2" value="Personal" checked={useptype.personal == true && usectype.commercial == false} />
                                      <label class="form-check-label" for="">Personal</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="commercial" onChange={(e) => handleChange(e)} id="inlixneRadio2" value="Commercial" checked={useptype.personal == false && usectype.commercial == true} />
                                      <label class="form-check-label" for="inlineRadio2">Commercial</label>
                                    </div>
                                  </div>
                                </div> */}
                                {state.int_use_type == "Commercial" ?
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Commercial Type: </label>
                                    <select class="form-select" onChange={(e) => handleChange(e)} name='usps_no'>
                                      {/* <option value="CSB V4">CSB V4</option> */}
                                      <option value="CSB-5">CSB V5</option>
                                      {/* <option value="CARGO">CARGO</option> */}
                                    </select>
                                  </div>
                                  : ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-4 mb-3">
                        <div class="col-12 col-md">
                          <h4 class="pb-1">SHIPPER / Consignor / From </h4><small>The Shipper Address must match the KYC information</small>
                          <div class="card mb-4">
                            <div class="card-body">
                              <section class="">
                                <div class="row">
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Company Name:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Full Name" name="company_name"
                                      value={state.company_name}
                                      onChange={handleChange} />
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Full Person Name <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Full Name" name="full_person_name"
                                      value={state.full_person_name}
                                      onChange={handleChange} />
                                  </div>
                                  <div class="col-12 col-md-12 mb-3">
                                    <label for="" class="form-label">Complete Address <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Complete Address" name="complete_address"
                                      value={state.complete_address}
                                      onChange={handleChange} />
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">Country <span class="text-danger">*</span>:</label>
                                    <select class="form-select" disabled>
                                      <option>{state.country}</option>
                                    </select>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">State <span class="text-danger">*</span>:</label>
                                    <select class="form-select" onChange={(e) => handleChangeShipperState(e)} >
                                      <option>Select</option>
                                      {stateList.map((item) => (
                                        <option value={JSON.stringify(item)} selected={item.state_name === state.state_name}>{item.state_name}</option>
                                      ))}
                                    </select>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">City <span class="text-danger">*</span>:</label>
                                    <select class="form-select" onChange={(e) => handleChangeShipperCity(e)}>
                                      <option>Select</option>
                                      {cityList.map((item) => (
                                        <option value={JSON.stringify(item)} selected={item.city_name == state.city}>{item.city_name}</option>
                                      ))}
                                    </select>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">Zipcode <span class="text-danger">*</span>: </label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Pincode" name="pincode" value={state.pincode}
                                      onChange={handleChange} />
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">Mobile Number <span class="text-danger">*</span>:</label>
                                    <div class="input-group">
                                      <span class="input-group-text">+1</span>
                                      <input type="number" class="form-control" placeholder="Enter Buyer's Mobile Number" name="mobile_number" value={state.mobile_number}
                                        onChange={handleChange} />
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">Email Id <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Email Id" name="email_id" value={state.email_id}
                                      onChange={handleChange} />
                                  </div>

                                  <div class="col-12 col-md-12 mb-3">
                                    <hr />
                                    <span class="text-danger text-uppercase">Need to upload any two KYC documents</span>
                                  </div>

                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">KYC Type <span class="text-danger">*</span>:</label>
                                    <select class="form-select" onChange={(e) => handleChange(e)} name='kyc_type_1' value={state.kyc_type_1}>
                                      <option value="AADHAAR NUMBER">AADHAAR NUMBER</option>
                                      <option value="PASSPORT NUMBER">PASSPORT NUMBER</option>
                                      <option value="VOTER ID">VOTER ID</option>
                                      <option value="PAN NUMBER">PAN NUMBER</option>
                                      <option value="GSTIN (NORMAL)">GSTIN (NORMAL)</option>
                                      <option value="DRIVING LICENSE">DRIVING LICENSE</option>
                                    </select>
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">KYC Number <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter KYC Number" name="kyc_number_1" onChange={(e) => handleChange(e)} value={state.kyc_number_1} />
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">KYC Type :</label>
                                    <select class="form-select" onChange={(e) => handleChange(e)} name='kyc_type_2' value={state.kyc_type_2}>
                                      <option value="AADHAAR NUMBER">AADHAAR NUMBER</option>
                                      <option value="PASSPORT NUMBER">PASSPORT NUMBER</option>
                                      <option value="VOTER ID">VOTER ID</option>
                                      <option value="PAN NUMBER">PAN NUMBER</option>
                                      <option value="GSTIN (NORMAL)">GSTIN (NORMAL)</option>
                                      <option value="DRIVING LICENSE">DRIVING LICENSE</option>
                                    </select>
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">KYC Number :</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter KYC Number" name="kyc_number_2" onChange={(e) => handleChange(e)} value={state.kyc_number_2} />
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Upload KYC Document <span class="text-danger">*</span>:</label>
                                    <input
                                      type="file"
                                      class="form-control"
                                      id="kyc_document_1"
                                      name="kyc_document_1"
                                      accept="image/*"
                                      onChange={(e) => handleFileChange(e, 'kyc_document_1')}

                                    />
                                    {state.kyc_document_1 && typeof state.kyc_document_1 === "string" && (
                                      <div className='mt-2'>
                                        <p>Current File: <a href={state.kyc_document_1} target="_blank" rel="noopener noreferrer" className='btn btn-primary'>View File</a></p>
                                      </div>
                                    )}

                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">&nbsp;</label>
                                    <input
                                      type="file"
                                      class="form-control"
                                      id="kyc_document_2"
                                      name="kyc_document_2"
                                      accept="image/*"
                                      onChange={(e) => handleFileChange(e, 'kyc_document_2')}

                                    />
                                    {state.kyc_document_2 && typeof state.kyc_document_2 === "string" && (
                                      <div className='mt-2'>
                                        <p>Current File: <a href={state.kyc_document_2} target="_blank" rel="noopener noreferrer" className='btn btn-primary'>View File</a></p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </section>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md">
                          <h4 class="pb-1">Consignee / Receiver / To  </h4>
                          <div class="card mb-4">
                            <div class="card-body">
                              <section class="">
                                <div class="row">
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Company Name:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Full Name" name="consignee_company_name"
                                      value={state.consignee_company_name}
                                      onChange={(e) => handleChange(e)} />
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Full Person Name <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Full Name" name="consignee_full_person_name"
                                      value={state.consignee_full_person_name}
                                      onChange={(e) => handleChange(e)} />
                                  </div>
                                  <div class="col-12 col-md-12 mb-3">
                                    <label for="" class="form-label">Complete Address <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Complete Address" name="consignee_complete_address"
                                      value={state.consignee_complete_address}
                                      onChange={(e) => handleChange(e)} />
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">Country <span class="text-danger">*</span>:</label>
                                    <select class="form-select" name="consignee_country" onChange={(e) => handleChangeConsigneeCountry(e)}>
                                      <option>Select</option>
                                      {countryList.map((item) => (
                                        <option value={JSON.stringify(item)} selected={item.country_name == state.consignee_country}>{item.country_name}</option>
                                      ))}
                                    </select>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">State <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter State Name" name="consignee_state_name"
                                      value={state.consignee_state_name}
                                      onChange={(e) => handleChange(e)} />
                                    {/* <select class="form-select" name="consignee_state" onChange={(e)=>handleChangeConsigneeState(e)} >
                            <option>Select</option>
                                {consigneestateList.map((item)=>(
                              <option value={JSON.stringify(item)}>{item.state_name}</option>
                            ))}
                            </select> */}
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">City <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter City Name" name="consignee_city"
                                      value={state.consignee_city}
                                      onChange={(e) => handleChange(e)} />
                                    {/* <select class="form-select" name="consignee_city" onChange={(e)=>handleChangeConsigneeCity(e)} >
                            <option>Select</option>
                                {consigneecityList.map((item)=>(
                              <option value={JSON.stringify(item)}>{item.city_name}</option>
                            ))}
                            </select> */}
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">Zipcode <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Pincode" name="consignee_pincode" value={state.consignee_pincode}
                                      onChange={handleChange} />
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">Mobile Number <span class="text-danger">*</span>:</label>
                                    <div class="input-group">
                                      <span class="input-group-text">{state.consignee_dialling_code}</span>
                                      <input type="number" class="form-control" placeholder="Enter Buyer's Mobile Number" name="consignee_mobile_number" value={state.consignee_mobile_number}
                                        onChange={handleChange} />
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                    <label for="" class="form-label">Email Id <span class="text-danger">*</span>:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter Email Id" name="consignee_email_id" value={state.consignee_email_id}
                                      onChange={handleChange} />
                                  </div>

                                  <div class="col-12 col-md-12 mb-3">
                                    <hr />
                                    <span class="text-danger text-uppercase">Need to upload any one KYC documents <span class="text-dark text-lowercase">(Not Mandatory for every country)</span></span>
                                  </div>

                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">KYC Type:</label>
                                    <select class="form-select" onChange={(e) => handleChange(e)} name='consignee_kyc_type' value={state.consignee_kyc_type}>
                                      <option value="LOCAL ID COPY">LOCAL ID COPY</option>
                                      <option value="VISA COPY">VISA COPY</option>
                                      <option value="PASSPORT COPY">PASSPORT COPY</option>
                                      <option value="CR COPY">CR COPY</option>
                                      <option value="OTHER">OTHER</option>

                                    </select>
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">KYC Number:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter KYC Number" name="consignee_kyc_number" onChange={(e) => handleChange(e)} value={state.consignee_kyc_number} />
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Upload KYC Document <span class="text-danger">*</span>:</label>
                                    <input
                                      type="file"
                                      class="form-control"
                                      id="consignee_kyc_document_1"
                                      name="consignee_kyc_document_1"
                                      accept="image/*"
                                      onChange={(e) => handleFileChange(e, 'consignee_kyc_document_1')}
                                    />
                                    {state.consignee_kyc_document_1 && typeof state.consignee_kyc_document_1 === "string" && (
                                      <div className='mt-2'>
                                        <p>Current File: <a href={state.consignee_kyc_document_1} target="_blank" rel="noopener noreferrer" className='btn btn-primary'>View File</a></p>
                                      </div>
                                    )}
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">&nbsp;</label>
                                    <input
                                      type="file"
                                      class="form-control"
                                      id="consignee_kyc_document_2"
                                      name="consignee_kyc_document_2"
                                      accept="image/*"
                                      onChange={(e) => handleFileChange(e, 'consignee_kyc_document_2')}
                                    />
                                    {state.consignee_kyc_document_2 && typeof state.consignee_kyc_document_2 === "string" && (
                                      <div className='mt-2'>
                                        <p>Current File: <a href={state.consignee_kyc_document_2} target="_blank" rel="noopener noreferrer" className='btn btn-primary'>View File</a></p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </section>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-md-12 mb-4">
                          <h4>Weights & Dimensions</h4>
                          <div class="card">
                            <div class="card-body">
                              <div class="row mb-3 justify-content-between">
                                <div class="col-12 col-md-2">
                                  <div class="row g-1">
                                    <div class="col-12 col-md-4 text-end">
                                      <small>PCS</small>
                                    </div>
                                    <div class="col-12 col-md"><input type="number" class="form-control form-control-sm" id="text" placeholder="" value={pcs}
                                      onChange={handlePcsChange}
                                      min={1} /></div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="row">
                                    <div class="col-12 col-md-6 text-end">
                                      <small>Actual Weight (KG)</small>
                                    </div>
                                    <div class="col-12 col-md"><input type="number" class="form-control form-control-sm" id="text" placeholder="0.00" value={totalActualWeight} disabled /></div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="row">
                                    <div class="col-12 col-md-7 text-end">
                                      <small>Volumetric Weight (KG)</small>
                                    </div>
                                    <div class="col-12 col-md"><input type="number" class="form-control form-control-sm" id="text" placeholder="0.00" value={totalVolumetricWeight} disabled /></div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="row">
                                    <div class="col-12 col-md-8 text-end">
                                      <small>Chargeable Weight (KG)</small>
                                    </div>
                                    <div class="col-12 col-md"><input type="number" class="form-control form-control-sm" id="text" placeholder="0.00" value={totalChargeableWeight} disabled /></div>
                                  </div>
                                </div>
                              </div>
                              <div class="table-responsive mt-3">
                                <table class="table table-bordered ">
                                  <thead class="bg-light">
                                    <tr>
                                      <th>Actual Wt.(Kg.) <span class="text-danger">*</span></th>
                                      <th>H(CM) <span class="text-danger">*</span></th>
                                      <th>W(CM) <span class="text-danger">*</span></th>
                                      <th>L(CM) <span class="text-danger">*</span></th>
                                      <th>Volumetric Wt.(Kg.)</th>
                                      <th>Chargeable Wt.(Kg.)</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {rows.map((row, index) => (
                                      <tr key={index}>
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={row.actualWeight}
                                            onChange={(e) => handleInputChange(e, index, 'actualWeight')}
                                            placeholder="Enter value"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={row.height}
                                            onChange={(e) => handleInputChange(e, index, 'height')}
                                            placeholder="Enter value"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={row.width}
                                            onChange={(e) => handleInputChange(e, index, 'width')}
                                            placeholder="Enter value"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={row.length}
                                            onChange={(e) => handleInputChange(e, index, 'length')}
                                            placeholder="Enter value"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={row.volumetricWeight}
                                            disabled
                                            placeholder="0.00"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={row.chargeableWeight}
                                            disabled
                                            placeholder="0.00"
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-12 mb-3 mt-3">
                            <h4>Shipment Invoice</h4>
                            <div class="card">
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-12 col-md-4 mb-3">
                                    <div class="row">
                                      <div class="col-12 col-md-4">
                                        <label for="email" class="form-label">Invoice Type:</label>
                                      </div>
                                      <div class="col-12 col-md">
                                        <select class="form-select" value={state.invoice_type}
                                          onChange={(e) => setState({ ...state, invoice_type: e.target.value })}>
                                          <option value="Invoice">Invoice</option>
                                          <option value="Proforma Invoice">Proforma Invoice</option>
                                          <option value="Commerical Invoice">Commerical Invoice</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div><div class="col-12 col-md-4 mb-3">
                                    <div class="row">
                                      <div class="col-12 col-md-4">
                                        <label for="email" class="form-label">Currency:</label>
                                      </div>
                                      <div class="col-12 col-md">
                                        <select class="form-select">
                                          <option>USD</option>

                                        </select>
                                      </div>
                                    </div>
                                  </div><div class="col-12 col-md-4 mb-3">
                                    <div class="row">
                                      <div class="col-12 col-md-4">
                                        <label for="email" class="form-label">INCOTERMS:</label>
                                      </div>
                                      <div class="col-12 col-md">
                                        <select class="form-select" value={state.incoterms}
                                          onChange={(e) => setState({ ...state, incoterms: e.target.value })}>
                                          <option value="CFR">CFR</option>
                                          <option value="CIF">CIF</option>
                                          <option value="CIP">CIP</option>
                                          <option value="CPT">CPT</option>
                                          <option value="DAP">DAP</option>
                                          <option value="DAT">DAT</option>
                                          <option value="DDP">DDP</option>
                                          <option value="DDU">DDU</option>

                                          <option value="DPU">DPU</option>
                                          <option value="EXW">EXW</option>
                                          <option value="FAS">FAS</option>
                                          <option value="FCA">FCA</option>
                                          <option value="FOB">FOB</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div><div class="col-12 col-md-4 mb-3">
                                    <div class="row">
                                      <div class="col-12 col-md-4">
                                        <label for="email" class="form-label">Invoice Note:</label>
                                      </div>
                                      <div class="col-12 col-md">
                                        <select class="form-select" value={state.invoice_note}
                                          onChange={(e) => setState({ ...state, invoice_note: e.target.value })}>
                                          <option value="SAMPLE">SAMPLE</option>
                                          <option value="GIFT">GIFT</option>
                                          <option value="SOLD">SOLD</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div><div class="col-12 col-md-8 mb-3">
                                    <div class="row">
                                      <div class="col-12 col-md">
                                        <input type="text" class="form-control" id="text" placeholder="Enter detail" value={state.invoice_note == "SAMPLE" ? "FREE TRADE SAMPLES OF NO COMMERCIAL VALUE" : state.invoice_note == "GIFT" ? "UNSOLICITED GIFT SENT TO MY FRIENDS & FAMILY MEMBERS FOR THERE PERSONAL USE ONLY" : "Commercial Shipment."} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="table-responsive mt-3">
                                  <table class="table table-bordered">
                                    <thead class="bg-light">
                                      <tr>
                                        <th>Box-No.</th>
                                        <th>Sr. No.</th>
                                        <th>Description	</th>
                                        <th>HS Code</th>
                                        <th>Unit Type</th>
                                        <th>Quantity</th>
                                        <th>IGST</th>
                                        <th>Unit Rates</th>
                                        <th>Amount</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {state.items.map((item, index) => (
                                        <tr key={index}>
                                          <td>
                                            <select
                                              className="form-select"
                                              value={item.box_no}
                                              onChange={(e) => handleChange1(e, index, "box_no")}
                                            >
                                              {/* Dynamically generate options based on the length of the rows */}
                                              {[...Array(rows.length)].map((_, n) => (
                                                <option key={n} value={n + 1}>
                                                  {n + 1}
                                                </option>
                                              ))}
                                            </select>
                                          </td>
                                          <td>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={item.sr_no}
                                              onChange={(e) => handleChange1(e, index, "sr_no")}
                                              placeholder="01"
                                              disabled
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={item.description}
                                              onChange={(e) => handleChange1(e, index, "description")}
                                              placeholder="Enter details"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={item.hs_code}
                                              onChange={(e) => handleChange1(e, index, "hs_code")}
                                              placeholder="Enter details"
                                            />
                                          </td>
                                          <td>
                                            <select
                                              className="form-select"
                                              value={item.unit_type}
                                              onChange={(e) => handleChange1(e, index, "unit_type")}
                                            >
                                              <option>Pkt</option>
                                              <option>Pc</option>
                                              <option>PCS</option>
                                              <option>Nos</option>
                                              <option>Bottle</option>
                                              <option>Pair</option>
                                              <option>Strip</option>
                                              <option>Dozen</option>
                                              <option>Gross</option>
                                              <option>Sets</option>
                                              <option>Box</option>
                                              <option>KG</option>
                                              <option>Gram</option>
                                              <option>Container</option>
                                              <option>Carats</option>
                                            </select>
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={item.quantity}
                                              onChange={(e) => handleChange1(e, index, "quantity")}
                                              min="1"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={item.igst}
                                              onChange={(e) => handleChange1(e, index, "igst")}
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={item.unit_rate}
                                              onChange={(e) => handleChange1(e, index, "unit_rate")}
                                              min="0"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={item.amount}
                                              disabled
                                            />
                                          </td>
                                          <td>
                                            {/* Conditionally render the add/remove icon */}
                                            {index === state.items.length - 1 ? (
                                              // If it's the last row, show the Add icon
                                              <a href="#" className="btn btn-primary" onClick={addNewRow}>
                                                <i className="bi bi-plus-lg"></i>
                                              </a>
                                            ) : (
                                              // Otherwise, show the Remove icon
                                              <a href="#" className="btn btn-danger" onClick={() => removeRow(index)}>
                                                <i className="bi bi-dash-lg"></i>
                                              </a>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="row">
                            <div class="col-12 col-md-8">
                              <p class="m-0 p-0">For inquiries about SEA or COMMERCIAL cargo, please contact our sales team at </p>
                              <p class="m-0 p-0 fw-bold">Email: <a href="mailto:sales@skyship.in">sales@skyship.in</a> or call <a href="callto:+918281071113">+91-8281071113</a></p>
                            </div>
                            {addbutton == false ?
                              <div class="col-12 col-md-4 mt-4 text-end">
                                <a onClick={(e) => saveOrder(e)} class="btn btn-primary btn-lg">Create Order</a>
                              </div>
                              : <div style={{
                                width: "100%", display: "flex",
                                justifyContent: "center"
                              }}>


                                <ReactLoading type={"spin"} color={"#0d6efd"} />
                              </div>}
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div></div>
            <Footer />
          </div></div></div>
    </div>
  )
}

export default Create_int_order
